<ada-card
	data-testid="ada-authoring-template-card"
	width="100%"
	[collapseEnabled]="true"
>
	<ada-text
		content="{{ propertyConstructor.namespace }} Settings"
		data-container-selector="ada-card-header"
	/>
	<ada-container
		data-container-selector="ada-card-body"
		horizontalSpacing="Medium"
		verticalSpacing="Medium"
		[colCount]="4"
		[padding]="defaultCardPadding"
	>
		<!-- Installer Type -->
		@if ('InstallerType' | displayAuthoringProperty: editorClass : propertyConstructor.namespace : forCustomization) {
		<ada-authoring-property-label
			[canInheritWhenRequired]="true"
			[content]="'Installer Type'"
			[inheriting]="(currentPropertyObject?.InstallerType | inheritPipe: inheritedPropertyObject?.InstallerType) || isInheritanceDisabled"
			[isDisabled]="isDisabled"
			[isRequired]="'InstallerType' | isRequiredProperty: editorClass : propertyConstructor.namespace"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
			(inheritanceChange)="deleteObjectPropertyValue('InstallerType')"
		/>
		<ada-container
			[colSpan]="3"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
		>
			<ada-combo
				data-testid="installer-type-input"
				[isDisabled]="isDisabled"
				[options]="installerTypeOptions"
				[placeholder]="'No Value'"
				[value]="
						currentPropertyObject?.InstallerType !== undefined
							? currentPropertyObject?.InstallerType
							: inheritedPropertyObject?.InstallerType
					"
				(userChange)="setObjectPropertyValue('InstallerType', $event)"
			/>
		</ada-container>
		}
		<!-- Pre Action Sequence -->
		<ng-container *ngIf="'PreActionSequence' | displayAuthoringProperty: editorClass : propertyConstructor.namespace : forCustomization">
			<ada-authoring-property-label
				[content]="'Pre Action Sequence'"
				[inheriting]="
					(currentPropertyObject?.PreActionSequence | inheritPipe: inheritedPropertyObject?.PreActionSequence) || isInheritanceDisabled
				"
				[isDisabled]="isDisabled"
				[isRequired]="'PreActionSequence' | isRequiredProperty: editorClass : propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="deleteObjectPropertyValue('PreActionSequence')"
			/>
			<ada-container
				[colSpan]="3"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			>
				<ada-sensor-action-sequence
					data-testid="pre-action-sequence"
					[availableProperties]="availableProperties"
					[contextClassName]="editorClass.className"
					[isDisabled]="isDisabled"
					[metadataObject]="serverObject$ | async"
					[propertyName]="propertyConstructor.namespace + '.PreActionSequence'"
					[sequence]="
						currentPropertyObject?.PreActionSequence !== undefined
							? currentPropertyObject?.PreActionSequence
							: inheritedPropertyObject?.PreActionSequence
					"
					(sequenceChange)="setObjectPropertyValue('PreActionSequence', $event)"
				/>
			</ada-container>
		</ng-container>
		<!-- Action Sequence -->
		<ng-container *ngIf="'ActionSequence' | displayAuthoringProperty: editorClass : propertyConstructor.namespace : forCustomization">
			<ada-authoring-property-label
				[content]="'Action Sequence'"
				[inheriting]="(currentPropertyObject?.ActionSequence | inheritPipe: inheritedPropertyObject?.ActionSequence) || isInheritanceDisabled"
				[isDisabled]="isDisabled"
				[isRequired]="'ActionSequence' | isRequiredProperty: editorClass : propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="deleteObjectPropertyValue('ActionSequence')"
			/>
			<ada-container
				[colSpan]="3"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			>
				<ada-sensor-action-sequence
					data-testid="action-sequence"
					[availableProperties]="availableProperties"
					[contextClassName]="editorClass.className"
					[isDisabled]="isDisabled"
					[metadataObject]="serverObject$ | async"
					[parentSequence]="inheritedPropertyObject?.ActionSequence"
					[propertyName]="propertyConstructor.namespace + '.ActionSequence'"
					[sequence]="
						currentPropertyObject?.ActionSequence !== undefined
							? currentPropertyObject?.ActionSequence
							: inheritedPropertyObject?.ActionSequence
					"
					(sequenceChange)="setObjectPropertyValue('ActionSequence', $event)"
				/>
			</ada-container>
		</ng-container>
		<!-- Customizer UI -->
		<ng-container *ngIf="'CustomizerUI' | displayAuthoringProperty: editorClass : propertyConstructor.namespace : forCustomization">
			<ada-authoring-property-label
				[content]="'Customizer UI'"
				[inheriting]="(currentPropertyObject?.CustomizerUI | inheritPipe: inheritedPropertyObject?.CustomizerUI) || isInheritanceDisabled"
				[isDisabled]="isDisabled"
				[isRequired]="'CustomizerUI' | isRequiredProperty: editorClass : propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="deleteCustomizerUi()"
			/>
			<ada-container
				[colCount]="0"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			>
				<ada-push-button
					#FormConfigButton
					id="FormConfigButton"
					[adaClick]="ConfigOverlay?.open | adaBindMethod: ConfigOverlay"
					[icon]="'faWrench'"
					[look]="'outline'"
					[size]="'small'"
					[text]="'Edit Configuration'"
				/>
				<ng-container
					*ngIf="
						currentPropertyObject?.CustomizerUI !== undefined
							? currentPropertyObject?.CustomizerUI
							: inheritedPropertyObject?.CustomizerUI as config
					"
				>
					<!-- Form Preview -->
					<ada-container [verticalSpacing]="'small'">
						<ada-text
							[content]="'UI Preview'"
							[fontWeight]="'bold'"
							[textColor]="'primary'"
						/>
						<ada-form-renderer
							#FormRenderer
							class="ada-background-color-background-2"
							data-testid="form-renderer-input-wrapper"
							style="width: 100%"
							[displayInitialErrors]="forCustomization"
							[formConfiguration]="config"
						/>
					</ada-container>
				</ng-container>
			</ada-container>
		</ng-container>
		<!-- Mandatory Customization Properties -->
		@if ('MandatoryCustomizerProperties' | displayAuthoringProperty: editorClass : propertyConstructor.namespace : forCustomization) {
		<ada-authoring-property-label
			content="Mandatory Product Customization"
			[inheriting]="
					(currentPropertyObject?.MandatoryCustomizerProperties | inheritPipe: inheritedPropertyObject?.MandatoryCustomizerProperties) ||
					isInheritanceDisabled
				"
			[isDisabled]="isDisabled"
			[isRequired]="'MandatoryCustomizerProperties' | isRequiredProperty: editorClass : propertyConstructor.namespace"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
			(inheritanceChange)="deleteObjectPropertyValue('MandatoryCustomizerProperties')"
		/>
		<ada-container
			[colSpan]="3"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
		>
			<ada-list-builder
				#MandatoryCustomizerPropertiesInput
				data-testid="mandatory-product-customization-builder"
				[isDisabled]="isDisabled"
				[value]="
						currentPropertyObject?.MandatoryCustomizerProperties !== undefined
							? currentPropertyObject?.MandatoryCustomizerProperties
							: inheritedPropertyObject?.MandatoryCustomizerProperties
					"
				(valueChange)="setObjectPropertyValue('MandatoryCustomizerProperties', $event)"
			/>
		</ada-container>
		}
		<!-- Post Action Sequence -->
		<ng-container *ngIf="'PostActionSequence' | displayAuthoringProperty: editorClass : propertyConstructor.namespace : forCustomization">
			<ada-authoring-property-label
				[content]="'Post Action Sequence'"
				[inheriting]="
					(currentPropertyObject?.PostActionSequence | inheritPipe: inheritedPropertyObject?.PostActionSequence) || isInheritanceDisabled
				"
				[isDisabled]="isDisabled"
				[isRequired]="'PostActionSequence' | isRequiredProperty: editorClass : propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="deleteObjectPropertyValue('PostActionSequence')"
			/>
			<ada-container
				[colSpan]="3"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			>
				<ada-sensor-action-sequence
					data-testid="post-action-sequence"
					[availableProperties]="availableProperties"
					[contextClassName]="editorClass.className"
					[isDisabled]="isDisabled"
					[metadataObject]="serverObject$ | async"
					[propertyName]="propertyConstructor.namespace + '.PostActionSequence'"
					[sequence]="
						currentPropertyObject?.PostActionSequence !== undefined
							? currentPropertyObject?.PostActionSequence
							: inheritedPropertyObject?.PostActionSequence
					"
					(sequenceChange)="setObjectPropertyValue('PostActionSequence', $event)"
				/>
			</ada-container>
		</ng-container>
		<!-- Auto IT Script -->
		<ng-container *ngIf="'AutoItScript' | displayAuthoringProperty: editorClass : propertyConstructor.namespace : forCustomization">
			<ada-authoring-property-label
				[content]="'Auto IT Script'"
				[inheriting]="(currentPropertyObject?.AutoItScript | inheritPipe: inheritedPropertyObject?.AutoItScript) || isInheritanceDisabled"
				[isDisabled]="isDisabled"
				[isRequired]="'AutoItScript' | isRequiredProperty: editorClass : propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="inheritAutoItScript()"
			/>
			<ada-container
				[colSpan]="3"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			>
				<ada-expression-language-editor
					#AutoItScriptEditor
					data-testid="auto-it-script-input"
					id="AutoItScriptEditor"
					[customCompletionItems]="availableProperties"
					[expression]="currentPropertyObject?.AutoItScript"
					[isDisabled]="isDisabled"
					[objectId]="(serverObject$ | async)?.objectId"
					[overridesClassName]="editorClass.className"
					[propertyMap]="serverObject$ | async | adaSerializedPropertyMap"
					(expressionChange)="autoItScriptChange($event)"
				/>
			</ada-container>
		</ng-container>
		<!-- Interfering Processes -->
		<ng-container *ngIf="'InterferingProcesses' | displayAuthoringProperty: editorClass : propertyConstructor.namespace : forCustomization">
			<ada-authoring-property-label
				#InterferingProcessLabel
				[content]="'Interfering Processes'"
				[inheriting]="
					(currentPropertyObject?.InterferingProcesses | inheritPipe: inheritedPropertyObject?.InterferingProcesses) ||
					isInheritanceDisabled
				"
				[isDisabled]="isDisabled"
				[isRequired]="'InterferingProcesses' | isRequiredProperty: editorClass : propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="deleteObjectPropertyValue('InterferingProcesses')"
			/>
			<ada-container
				[colSpan]="3"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			>
				<ada-list-builder
					data-testid="interfering-process-builder"
					[isDisabled]="isDisabled"
					[value]="
						currentPropertyObject?.InterferingProcesses !== undefined
							? currentPropertyObject?.InterferingProcesses
							: inheritedPropertyObject?.InterferingProcesses
					"
					(valueChange)="setObjectPropertyValue('InterferingProcesses', $event)"
				/>
			</ada-container>
		</ng-container>
		<!-- Interfering Processes To Wait For -->
		<ng-container
			*ngIf="'InterferingProcessesToWaitFor' | displayAuthoringProperty: editorClass : propertyConstructor.namespace : forCustomization"
		>
			<ada-authoring-property-label
				#InterferingProcessesToWaitForLabel
				[content]="'Interfering Processes to Wait For'"
				[inheriting]="
					(currentPropertyObject?.InterferingProcessesToWaitFor | inheritPipe: inheritedPropertyObject?.InterferingProcessesToWaitFor) ||
					isInheritanceDisabled
				"
				[isDisabled]="isDisabled"
				[isRequired]="'InterferingProcessesToWaitFor' | isRequiredProperty: editorClass : propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="deleteObjectPropertyValue('InterferingProcessesToWaitFor')"
			/>
			<ada-container
				[colSpan]="3"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			>
				<ada-list-builder
					data-testid="interfering-processes-to-wait-for-builder"
					[isDisabled]="isDisabled"
					[value]="
						currentPropertyObject?.InterferingProcessesToWaitFor !== undefined
							? currentPropertyObject?.InterferingProcessesToWaitFor
							: inheritedPropertyObject?.InterferingProcessesToWaitFor
					"
					(valueChange)="setObjectPropertyValue('InterferingProcessesToWaitFor', $event)"
				/>
			</ada-container>
		</ng-container>
		<!-- Internet Required -->
		<ng-container *ngIf="'InternetRequired' | displayAuthoringProperty: editorClass : propertyConstructor.namespace : forCustomization">
			<ada-authoring-property-label
				[content]="'Internet Required'"
				[inheriting]="
					(currentPropertyObject?.InternetRequired | inheritPipe: inheritedPropertyObject?.InternetRequired) || isInheritanceDisabled
				"
				[isDisabled]="isDisabled"
				[isRequired]="'InternetRequired' | isRequiredProperty: editorClass : propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="deleteObjectPropertyValue('InternetRequired')"
			/>
			<ada-container
				[colSpan]="3"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			>
				<ada-toggle-switch
					data-testid="internet-required-input"
					[isDisabled]="isDisabled"
					[isToggled]="currentPropertyObject?.InternetRequired"
					(isToggledChange)="setObjectPropertyValue('InternetRequired', $event)"
				/>
			</ada-container>
		</ng-container>
		<!-- Logged On User -->
		<ng-container *ngIf="'LoggedOnUser' | displayAuthoringProperty: editorClass : propertyConstructor.namespace : forCustomization">
			<ada-authoring-property-label
				[content]="'Logged On User'"
				[inheriting]="(currentPropertyObject?.LoggedOnUser | inheritPipe: inheritedPropertyObject?.LoggedOnUser) || isInheritanceDisabled"
				[isDisabled]="isDisabled"
				[isRequired]="'LoggedOnUser' | isRequiredProperty: editorClass : propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="deleteObjectPropertyValue('LoggedOnUser')"
			/>
			<ada-container
				[colSpan]="3"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			>
				<ada-combo
					data-testid="logged-on-user-input"
					[isDisabled]="isDisabled"
					[options]="requiredOptions"
					[placeholder]="'No Value'"
					[value]="
						currentPropertyObject?.LoggedOnUser !== undefined
							? currentPropertyObject?.LoggedOnUser
							: inheritedPropertyObject?.LoggedOnUser
					"
					(valueChange)="setObjectPropertyValue('LoggedOnUser', $event)"
				/>
			</ada-container>
		</ng-container>
		<!-- Requires Reboot -->
		<ng-container *ngIf="'RequiresReboot' | displayAuthoringProperty: editorClass : propertyConstructor.namespace : forCustomization">
			<ada-authoring-property-label
				[content]="'Requires Reboot'"
				[inheriting]="(currentPropertyObject?.RequiresReboot | inheritPipe: inheritedPropertyObject?.RequiresReboot) || isInheritanceDisabled"
				[isDisabled]="isDisabled"
				[isRequired]="'RequiresReboot' | isRequiredProperty: editorClass : propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="deleteObjectPropertyValue('RequiresReboot')"
			/>
			<ada-container
				[colSpan]="3"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			>
				<ada-combo
					data-testid="requires-reboot-input"
					[isDisabled]="isDisabled"
					[options]="requiredOptions"
					[placeholder]="'No Value'"
					[value]="
						currentPropertyObject?.RequiresReboot !== undefined
							? currentPropertyObject?.RequiresReboot
							: inheritedPropertyObject?.RequiresReboot
					"
					(valueChange)="setObjectPropertyValue('RequiresReboot', $event)"
				/>
			</ada-container>
		</ng-container>
		<!-- Disk Space Required -->
		<ng-container *ngIf="'DiskSpaceRequired' | displayAuthoringProperty: editorClass : propertyConstructor.namespace : forCustomization">
			<ada-authoring-property-label
				[content]="'Disk Space Required'"
				[inheriting]="
					(currentPropertyObject?.DiskSpaceRequired | inheritPipe: inheritedPropertyObject?.DiskSpaceRequired) || isInheritanceDisabled
				"
				[isDisabled]="isDisabled"
				[isRequired]="'DiskSpaceRequired' | isRequiredProperty: editorClass : propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="deleteObjectPropertyValue('DiskSpaceRequired')"
			>
				<ada-text
					content="Number of bytes required on disk"
					data-container-selector="label-info-text"
				/>
			</ada-authoring-property-label>
			<ada-container
				[colSpan]="3"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			>
				<ada-input
					data-testid="disk-space-required-input"
					type="number"
					[isDisabled]="isDisabled"
					[min]="0"
					[placeholder]="'Number of bytes'"
					[value]="
						currentPropertyObject?.DiskSpaceRequired !== undefined
							? currentPropertyObject?.DiskSpaceRequired
							: inheritedPropertyObject?.DiskSpaceRequired
					"
					(valueChange)="setObjectPropertyValue('DiskSpaceRequired', +$event)"
				/>
			</ada-container>
		</ng-container>
		<!-- Max Run Time -->
		<ng-container *ngIf="'MaxRunTime' | displayAuthoringProperty: editorClass : propertyConstructor.namespace : forCustomization">
			<ada-authoring-property-label
				[content]="'Max Run Time'"
				[inheriting]="(currentPropertyObject?.MaxRunTime | inheritPipe: inheritedPropertyObject?.MaxRunTime) || isInheritanceDisabled"
				[isDisabled]="isDisabled"
				[isRequired]="'MaxRunTime' | isRequiredProperty: editorClass : propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="deleteObjectPropertyValue('MaxRunTime')"
			/>
			<ada-container
				[colSpan]="3"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			>
				<ada-time-scale
					data-testid="max-run-time-input"
					[scaleConfiguration]="maxRuntimeScaleConfig"
					[value]="
						currentPropertyObject?.MaxRunTime !== undefined ? currentPropertyObject?.MaxRunTime : inheritedPropertyObject?.MaxRunTime
					"
					(valueChange)="setObjectPropertyValue('MaxRunTime', $event)"
				/>
			</ada-container>
		</ng-container>
	</ada-container>
</ada-card>
<!-- FormConfiguration Overlay -->
<ada-overlay
	#ConfigOverlay
	id="ConfigOverlay"
	[title]="'Customizer UI Configuration'"
	(submit)="onConfigurationSubmit($event)"
>
	<div
		*adaTemplateMarker
		class="ada-container ada-col-1"
		style="height: 100%"
	>
		<ada-form-configuration-editor
			configurationTitle="Customizer UI"
			[isDisabled]="isDisabled || forCustomization"
			[(formConfiguration)]="formConfiguration"
		/>
	</div>
</ada-overlay>
<ada-overlay
	#PrereqSensorOverlay
	id="PrereqSensorOverlay"
	[title]="(expressionEditingIndex > -1 ? 'Editing' : 'Adding') + ' Prerequisite Sensor Expression'"
	(submit)="addPrereqExpression()"
>
	<ada-container
		*adaTemplateMarker
		[height]="'100%'"
		[padding]="UI.Spacing.SPACING_LARGE"
	>
		<ada-expression-language-editor
			data-testid="form-configuration-overlay-expression-input"
			[customCompletionItems]="availableProperties"
			[objectId]="(serverObject$ | async)?.objectId"
			[overridesClassName]="editorClass.className"
			[propertyMap]="serverObject$ | async | adaSerializedPropertyMap"
			[width]="'100%'"
			[(expression)]="selectedPrereqExpression"
		/>
	</ada-container>
</ada-overlay>
